import AppDropdown from '@/components/AppDropdown';
import { EllipsisOutlined } from '@ant-design/icons';
import { Button } from 'antd';

const RowAction = ({ record, onDelete = () => {}, onEdit = () => {} }) => {
  return (
    <AppDropdown
      options={[
        {
          key: '1',
          label: 'Edit',
          onClick: onEdit,
        },
        {
          key: '2',
          label: 'Delete',
          onClick: onDelete,
        },
      ]}
      onChange={(item) => item.onClick()}
      placement="bottomRight"
      overlayStyle={{ minWidth: '150px' }}
    >
      <Button type="text" className="px-2">
        <EllipsisOutlined />
      </Button>
    </AppDropdown>
  );
};

export default RowAction;
